import {Box} from "@cjdev-internal/visual-stack";
import {ToggleIcon as VSRToggleIcon,} from '@cjdev-internal/visual-stack-redux/lib/components/SlidingPanel';
import {Text} from "@cjdev-internal/visual-stack/lib/components/Text";
import * as appConstant from "../../constants/appConstant";
import "../../App.css";

const AppHeader = (CreateRecordModal, DateFilter, ExcelDownload) => {
    return function AppHeader({
                                  panelActive,
                                  setPanelActive
                              }) {
        return (
            <Box direction="row" justify="space-between" padding="medium">
                <Box direction="row" gap="medium">
                    <Text weight="medium" className="margin-top-5">{appConstant.PLACEMENT_RUN_DATE}</Text>
                    <DateFilter/>
                </Box>
                <Box direction="row">
                    <Box direction="row" gap={"medium"}>
                    <CreateRecordModal/>
                    <ExcelDownload/>
                    </Box>
                    <VSRToggleIcon label="Filters"
                                   toggleIconState={panelActive}
                                   onClick={() => (setPanelActive(!panelActive))}
                    />
                </Box>
            </Box>
        );
    }
}

export default AppHeader;